import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { formatDate } from '../../helpers/dateConverters';
import type { PostDraftInterface } from '../../interfaces/post.interface';
import type { TextBlock } from '../../interfaces/textEditor.interface';
import './drafts.scss';

type UserPostsProps = {
  draftPosts: PostDraftInterface[];
};

export default function PostDrafts(props: UserPostsProps) {
  const params = useParams();
  const { username } = params;
  const dispatch = useDispatch();
  const { draftPosts } = props;
  const [reversedDrafts, setReversedDrafts] = React.useState<
    PostDraftInterface[]
  >([]);
  const getTitle = (textBlocks: TextBlock[]) => {
    const headingBlock = textBlocks?.find(
      (block) => block.type === 'Heading' && block.data?.level === 1,
    );
    return headingBlock ? headingBlock.data?.header : 'Untitled Post';
  };

  useEffect(() => {
    if (draftPosts) {
      const reversed = draftPosts?.length ? [...draftPosts].reverse() : [];
      setReversedDrafts(reversed);
    }
  }, [draftPosts]);

  return (
    <div className="DRAFTS__CONTAINER">
      {reversedDrafts === null ||
      reversedDrafts === undefined ||
      reversedDrafts.length < 1 ? (
        <>No Drafts</>
      ) : (
        reversedDrafts?.map((draft: PostDraftInterface) => (
          <div className="DRAFT__ITEM" key={`${draft.id}`}>
            <Link
              id={`${draft.id}`}
              style={{ textDecoration: 'none' }}
              to={`/draft/${draft.id}`}
            >
              <div className="DRAFT__CARD">
                <div className="DRAFT__CARD__CONTENT">
                  <h6 className="DRAFT__CARD__TITLE">
                    {getTitle(draft.textBlocks)}
                  </h6>
                  <p className="DRAFT__CARD__DATE">
                    Created on: {formatDate(draft.createdAt as Date)}
                    {draft.updatedAt && draft.updatedAt !== draft.createdAt && (
                      <> — Updated on: {formatDate(draft.updatedAt as Date)}</>
                    )}
                  </p>
                </div>
              </div>
            </Link>
          </div>
        ))
      )}
    </div>
  );
}
